const URL = {
  APPSUMO_SIGNUP: 'auth/registerWithPromoCode',
}

export default URL
